import campusSafetyAlertService from "../../apiServices/common/campusSafetyAlertService";
import { setSafetyAlert } from "../../store/slices/common/campusSafetyAlertSlice";

export function getCampusSafetyAlertDetail() {
    return async function (dispatch: any, getState: any) {
        let response = await campusSafetyAlertService.getSafetyAlerts();
        if (response?.success === true) {
            dispatch(setSafetyAlert(response.data));
        } else {
            console.log("error");
        }
    };
}